import gql from "graphql-tag";

export const CREATE_CLAIMED_PROPERTY = gql`
  mutation createClaimedProperty(
    $address: String!
    $listPrice: Int
    $unitNumber: String,
    $contactFrequency: String
  ) {
    createClaimedProperty(
      address: $address
      listPrice: $listPrice
      unitNumber: $unitNumber,
      contactFrequency: $contactFrequency
    ) {
      property {
        id
      }
    }
  }
`;

export const CLAIMED_PROPERTIES_AUTOCOMPLETE = gql`
  query claimedPropertiesAutocomplete($input: String!) {
    claimedPropertiesAutocomplete(input: $input) {
      type
      places {
        description
        type
        placeId
      }
    }
  }
`;

export const GET_USER = gql`
  query getUser {
    getUser {
      canClaimProperty
    }
  }
`;
